import { useAccountRepository } from '@frontend/repository';
import { FormattedMessage } from 'react-intl';

import AwaitingDropOff from '../../../statistics/pudo/awaiting-drop-off/awaiting-drop-off.component';
import AwaitingPickUp from '../../../statistics/pudo/awaiting-pick-up/awaiting-pick-up.component';
import { Last30DaysPudoSpotFillRateLineChart } from '../../../statistics/pudo/last-30-days-pudo-spot-fill-rate-line-chart/last-30-days-pudo-spot-fill-rate-line-chart.component';
import { Last30DaysPudoTransactionVolumeByStateListChart } from '../../../statistics/pudo/last-30-days-pudo-transaction-volume-by-state-list-chart/last-30-days-pudo-transaction-volume-by-state-list-chart.component';
import { Last30DaysPudoTransactionVolumeLineChart } from '../../../statistics/pudo/last-30-days-pudo-transaction-volume-line-chart/last-30-days-pudo-transaction-volume-line-chart.component';
import { Last60DaysPudoDailyFillRateMetricChart } from '../../../statistics/pudo/last-60-days-pudo-daily-fill-rate-metric-chart/last-60-days-pudo-daily-fill-rate-metric-chart.component';
import { Last60DaysPudoTransactionDropOffTimeMetricChart } from '../../../statistics/pudo/last-60-days-pudo-transaction-drop-off-time-metric-chart/last-60-days-pudo-transaction-drop-off-time-metric-chart.component';
import { Last60DaysPudoTransactionPickUpTimeMetricChart } from '../../../statistics/pudo/last-60-days-pudo-transaction-pick-up-time-metric-chart/last-60-days-pudo-transaction-pick-up-time-metric-chart.component';
import { Dashboard, DashboardCard } from '../../../statistics/shared';
import OverviewHeader from '../../header/overview-header';

const PuDoDashboard = () => {
    const { currentAccount } = useAccountRepository();

    return (
        <div
            key='pudo-dashboard'
            className='bg-background-default flex w-full flex-col items-start justify-start gap-6 self-stretch'>
            <OverviewHeader
                title={
                    <FormattedMessage
                        id='platform.applications.pudo.dashboard.title'
                        description='Page title for the PuDo application dashboard'
                        defaultMessage='PuDo / Dashboard'
                    />
                }
            />
            <Dashboard>
                <DashboardCard size='3x1'>
                    <AwaitingDropOff
                        accountId={currentAccount}
                        navigateUrl='../awaiting_drop_off'
                    />
                </DashboardCard>
                <DashboardCard size='3x1'>
                    <AwaitingPickUp
                        accountId={currentAccount}
                        navigateUrl='../awaiting_pick_up'
                    />
                </DashboardCard>
                <DashboardCard size='2x1'>
                    <Last30DaysPudoTransactionVolumeByStateListChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='4x2'>
                    <Last30DaysPudoTransactionVolumeLineChart
                        accountId={currentAccount}
                        navigateUrl='../transactions'
                    />
                </DashboardCard>
                <DashboardCard size='4x2'>
                    <Last30DaysPudoSpotFillRateLineChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='2x1'>
                    <Last60DaysPudoTransactionDropOffTimeMetricChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='2x1'>
                    <Last60DaysPudoTransactionPickUpTimeMetricChart accountId={currentAccount} />
                </DashboardCard>
                <DashboardCard size='2x1'>
                    <Last60DaysPudoDailyFillRateMetricChart accountId={currentAccount} />
                </DashboardCard>
            </Dashboard>
        </div>
    );
};

export default PuDoDashboard;
